export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/weWingmanWorker.worker.2c372fc8.worker.js");
}
